export const msalConfig = {
  auth: {
    clientId: "af873936-e2bc-4eb4-b002-26dd7c19c56c",
    authority: "https://login.microsoftonline.com/f8d69688-de39-4536-961c-db87fb9c8f20",
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "User.Read.All",
    "Directory.Read.All"
  ]
};